import moment from "moment";

// 判断是否是空值
export function isValueEmpty(value) {
  return value === undefined || (typeof value === 'string' && !value.trim());
}

// 判断邮箱是否正确
export function isEmail(value) {
  return /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/.test(value.toLowerCase());
}

// 判断是不是可转化为数字
export function isNum(data) {
  if (data === '' || data === null) {
    return false;
  }
  const numData = Number(data);
  return !Number.isNaN(numData);
}

// 判断一个数是不是正整数
export function isPositiveIntegerNum(value) {
  return isNum(value) && value > 0 && Number.parseInt(value, 10) === Number.parseFloat(value);
}

// 判断是不是移动端
export function isMobileOrPc() {
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

// 判断是不是正数
export function isPositiveNum (numString) {
  let numData = Number(numString);
  return numData > 0;
}

/**
 * 1.10 => 1.1
 * @param {number} number
 * @param {number} digit
 */
export function formatNumber(number, digit = 2) {
  if (/^([1-9]\d*|[0])$/.test(String(number))) { // 0 或者是正整数
    return number;
  }
  return Number.parseFloat(Number(number).toFixed(digit));
}

export function debounce (func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

export function throttle (fn, wait) {
  let timer, previous, now, diff;
  return function () {
    let _args = [].slice.call(arguments);
    let context = this;
    now = Date.now();

    let _fn = function () {
      previous = Date.now();
      timer = null;
      fn.apply(context, _args);
    };

    clearTimeout(timer);

    if (previous !== undefined) {
      diff = now - previous;
      if (diff >= wait) {
        fn.apply(context, _args);
        previous = now;
      } else {
        timer = setTimeout(_fn, wait);
      }
    } else {
      _fn();
    }
  };
}

/**
 * @return {boolean}
 */
export function IsFontExist (t) {
  if (t === '') {
    return false;
  }
  let f = 'Copyright © 心のsky Group';
  let s = document.createElement('span');
  s.style.fontSize = '72px';
  s.innerHTML = f;
  let b = document.getElementsByTagName('body')[0];
  b.appendChild(s);
  s.style.fontFamily = f;
  let w = s.offsetWidth;
  let h = s.offsetHeight;
  s.style.fontFamily = t + ',' + f;
  let r = ((s.offsetWidth !== w) || (s.offsetHeight !== h));
  b.removeChild(s);
  return r;
}

export function getQueryVariable(variable) {
  let str = decodeURI(window.location.href);
  let index = str.indexOf('?');
  str = str.substr(index + 1);
  let arr = str.split('&');
  let num, name, value;
  for(let i= 0;i < arr.length;i++) {
    num = arr[i].indexOf("=");
    name= arr[i].substring(0,num);
    value= arr[i].substr(num+1);
    if (name === variable) {
      return value;
    }
  }
  return false;
}

export function remove_ie_header_and_footer() {
  let hkey_path;
  hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
  try {
    let RegWsh = new ActiveXObject("WScript.Shell");
    RegWsh.RegWrite(hkey_path + "header", "");
    RegWsh.RegWrite(hkey_path + "footer", "");
  } catch (e) {
  }
}

export function findNode(tree, func) {
  const list = [...tree]
  for (const node of list) {
    if (func(node)) return node
    node['children'] && list.push(...node['children'])
  }
  return null
}

/**
 * 
 * @param {年周号定义：以周日作为每周的第一天，新年第一天落在周日至周三时，所在周为该年的第一周；
 * 若新年第一天落在周四至周六时，则所在周为上一年的最后一周，该年的第一周从下一周开始计算；
 * 第一周确定后,其后依次为02周,03周,……,52周或53周} 
 * @returns 
 */
export function getWeek(date) {
  let value = getThursdayDate(date);
  let fullYear = moment(value).year(),
      timestamp = moment(value).valueOf(),
      timeObj = moment(value).startOf('year');
  //获取1月1日获取属于星期几
  let day = timeObj.day();
  //第一周开始的时间戳
  let firstWeekTimestamp = 0;
  if ([0,1,2,3].includes(day)) {
      //1月1日属于第一周
      firstWeekTimestamp = (timeObj.valueOf()) - (day * 24 * 3600000);
  } else {
      let num = day > 0 ? 8 : 1;
      //1月1日  不属于第一周
      firstWeekTimestamp = (timeObj.valueOf()) +  (num - day) * 24 * 3600000;
  }
  if (timestamp >= firstWeekTimestamp) {
      //如果属于本年度的周数
      let num = Math.ceil((timestamp - firstWeekTimestamp) / 7 / 24 / 3600000);
      return `${moment(fullYear, 'YYYY').format('YY')}${String(num).padStart(2, '0')}`;
  } else {
      //如果属于上一年的周数
      let string = (fullYear - 1) + "/12/28";
      return getWeek(string);
  }
}

//获取周四的时间戳
function getThursdayDate (date) {
  let dateObj = moment(date), timestamp = dateObj.valueOf();
  let day = dateObj.day();
  if ([0, 1, 2, 3].includes(day)) {
      timestamp += (4 - day) * 24 * 3600000;
  } else if ([5, 6].includes(day)) {
      timestamp -= (day - 4) * 24 * 3600000;
  }
  return timestamp;
}
